var map = {
	"./environment.dev": [
		7393,
		7393
	],
	"./environment.dev.ts": [
		7393,
		7393
	],
	"./environment.local": [
		7501,
		7501
	],
	"./environment.local.ts": [
		7501,
		7501
	],
	"./environment.prod": [
		4841,
		4841
	],
	"./environment.prod.ts": [
		4841,
		4841
	],
	"./environment.stage": [
		9931,
		2312
	],
	"./environment.stage.ts": [
		9931,
		2312
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8694;
module.exports = webpackAsyncContext;